<template>
  <header class="c-topbar" :class="{'c-topbar--no-filter':!has_filters}">
    <SearchBox v-if="!is_mobile"/>
    <SolutionFilters v-if="has_filters"/>
  </header>
</template>

<script>
import SearchBox from "@/components/SearchBox.vue";
import SolutionFilters from "@/components/SolutionFilters.vue";
export default {
  components: {
    SearchBox,
    SolutionFilters
  },
  data(){
    return{
      has_filters: process.env.VUE_APP_FILTERS==='true'
    }
  },
  computed:{
    is_mobile(){
      return window.innerWidth<1024
    }
  }
}
</script>

<style lang="scss">
.c-topbar{
  position: absolute; left: $space-m; top: $space; right: $space-m; height: 4.8rem; z-index: 10002; display: flex;
  font-size: $font-xs; grid-gap: $space-s; justify-content: space-between;
  &--no-filter{ justify-content: flex-end }
  @media #{$to-phone} { right: $space; left: $space }
  .c-solution-filters{
    cursor: auto;
    &__item{
      @media #{$to-phone} {
        display: none;
        &--online{
          display: inline-block; transition: allow(transform opacity);
        }
      }
    }
  }
}
</style>
